import { Toaster } from '@treasuryspring/spring-ui';

import { Banner, RateCard } from '@/components';

export default function RatesPage() {
  return (
    <>
      <Banner />
      <RateCard />
      <Toaster />
    </>
  );
}
